import { render, staticRenderFns } from "./OrganizationProjects.vue?vue&type=template&id=61b30243&scoped=true&"
import script from "./OrganizationProjects.vue?vue&type=script&lang=js&"
export * from "./OrganizationProjects.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationProjects.vue?vue&type=style&index=0&id=61b30243&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b30243",
  null
  
)

export default component.exports